import React from "react";
import { extractDataFromArray, logoutCookies, no_event_src } from "../utils/utils&validatation";
import PageHeader from "../components/Header";
import { useNavigate } from "react-router-dom";
import { eventSlotListApi, isUserLoggedInApi, signOutApi } from "../apis/authService";
import Divider from "../components/Divider";
import Loader from "../components/Loader";
import useReloadOnBack from "./hooks/useReloadOnBack";
import CustomPopup from "../components/CustomPopup";
import { ArrowRight } from "lucide-react";
import Button from "../components/Button";

const EventSlots = () => {
    const navigate = useNavigate();

    const [open, setOpen] = React.useState(false);
    const [data, setData] = React.useState(null);
    const [isLoggedIn, setIsLoggedIn] = React.useState("checking");

    const handleLogout = React.useCallback(async () => {
        try {
            const res = await signOutApi({ cmd: "signOut" });
            if (extractDataFromArray(res, ["errorCode"], 1) == 0) {
                logoutCookies();
                navigate("/event-scanner/login");
            }
        } catch (err) {
            console.error("Error inside signOutApi =>", err)
        }
    }, [navigate]);

    // Check Login Status
    React.useEffect(() => {
        const verifyUser = async () => {
            try {
                const res = await isUserLoggedInApi({ cmd: "isUserLoggedIn" });
                if (extractDataFromArray(res, ["errorCode"]) === 0) {
                    window.user_info = extractDataFromArray(res, ["data"]);
                    setIsLoggedIn("logged-in");
                } else {
                    setIsLoggedIn("logged-out");
                }
            } catch {
                setIsLoggedIn("logged-out");
            }
        };
        verifyUser();
    }, []);

    // Auto-logout if needed
    React.useEffect(() => {
        if (isLoggedIn === "logged-out") handleLogout();
    }, [isLoggedIn, handleLogout]);

    // Fetch Events When Logged In
    React.useEffect(() => {
        const fetchEvents = async () => {
            try {
                const res = await eventSlotListApi({ cmd: "fetchOngoingEventsList" });
                setData(res?.data[0] || []);
            } catch (err) {
                console.log("Error fetching events:", err);
            }
        };
        // fetchEvents();
        if (isLoggedIn === "logged-in") fetchEvents();
    }, [isLoggedIn]);

    useReloadOnBack();

    const baseSrc = no_event_src();

    return (
        <div className="flex h-full col-flex w-full">
            <div className="flex h-full col-flex w-full">
                <PageHeader />
                <Divider />

                {data === null ? (
                    <Loader />
                ) : data?.count?.length === 0 ? (
                    <div
                        className="w-90 flex col-flex justify-center"
                        style={{ height: "70%", margin: "0 5%", gap: "16px" }}
                    >
                        <img
                            src={`${baseSrc}/assets/images/no_event.svg`}
                            alt="no_event.svg"
                            style={{
                                display: "block",
                                width: "65%",
                                margin: "0 auto",
                                height: "auto",
                            }}
                        />
                        <p
                            style={{
                                color: "#6a7282",
                                textAlign: "center",
                                fontSize: "20px",
                            }}
                        >
                            No event ticket found
                        </p>
                        <p
                            style={{
                                color: "#6a7282",
                                textAlign: "center",
                                fontSize: "20px",
                            }}
                        >
                            Your account doesn't have any active event tickets to validate. You need to create one to start checking in guests.
                        </p>
                        <Button
                            buttonText="Create Event Tickets"
                            onClick={() => window.open(`${window.location.origin}/event-ticket-qr-code`, "_blank")}
                            style={{
                                fontSize: "18px",
                                padding: 'none',
                            }}
                        />
                    </div>
                ) : (
                    <div
                        className="w-90 flex col-flex justify-center"
                        style={{ height: "70%", margin: "0 5%", gap: "16px" }}
                    >
                        <p
                            style={{
                                color: "#6a7282",
                                textAlign: "center",
                                fontSize: "16px",
                            }}
                        >
                            Choose the event and time slot you want to manage
                        </p>

                        <div
                            className="br-8 p-12"
                            style={{
                                width: "auto",
                                display: "flex",
                                justifyContent: "space-between",
                                backgroundColor: "#f9fafb",
                                border: "2px solid #e2e8f0",
                                backgroundClip: "padding-box",
                                cursor: "pointer",
                            }}
                        >
                            <b
                                onClick={() => setOpen(true)}
                                style={{
                                    padding: "8px",
                                    color: "#4d77fa",
                                    width: "90%",
                                    fontSize: "18px",
                                }}>
                                Click here to choose an event
                            </b>
                            <div
                                onClick={() => setOpen(true)}
                                style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                            ><ArrowRight width={30} height={30} color={"#6a7282"} /></div>
                            {
                                open &&
                                <CustomPopup
                                    data={data}
                                    onClose={() => setOpen(false)}
                                />
                            }
                        </div>
                    </div>
                )}
            </div>
            <p style={{ textAlign: "center", color: "#6a7282", }}>© 2026 QRCodeChimp. All Rights Reserved.</p>
        </div>
    );
};

export default EventSlots;